import Footer from './Footer';
import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';
function Layout({ children }) {
  return (
    <div>
      <Navbar />
      <div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
